import { Controller } from "stimulus";
import useEventController from "../composables/use_event_controller";

export default class extends Controller {
  static targets = ["onChange"];

  connect() {
    useEventController(this);

    this.onChangeTargets.forEach((target) => {
      this.listenOn(target, "change", this.onChange.bind(this));
      this.removeFromForm(target);
    });
  }

  removeFromForm(target) {
    if (target.hasAttribute("name")) {
      target.setAttribute("_name", target.getAttribute("name"));
      target.removeAttribute("name");
    }
  }

  onChange() {
    this.onChangeTargets.forEach((target) => {
      if (target.hasAttribute("_name")) {
        target.setAttribute("name", target.getAttribute("_name"));
        target.removeAttribute("_name");
      }
    });
  }
}
